import { Box } from "@outschool/backpack";
import { PublicReviewFragmentFragment } from "@outschool/gql-frontend-generated";
import { useMachineTranslation, useTranslation } from "@outschool/localization";
import { parentPath } from "@outschool/routes";
import { CollapsedText } from "@outschool/ui-legacy-component-library";
import React from "react";

import StarRatings from "../StarRatings";
import { ReviewHeader } from "./ReviewHeader";

type ReviewCaptionProps = {
  review: PublicReviewFragmentFragment;
};

export const ReviewCaption: React.FunctionComponent<ReviewCaptionProps> = ({
  review,
}) => {
  const { translate } = useMachineTranslation();
  const { t } = useTranslation(
    "ui-components-website\\src\\Reviews\\PublicReviewQuote\\ReviewCaption"
  );
  // @ts-ignore TS(2345): Argument of type 'string | null | undefined' is no... Remove this comment to see the full error message
  const publicReview = translate(review?.details?.publicReview);
  const maxReviewTextChars = 190;
  const name =
    (review && review.parent && review.parent.publicName) || "a parent";
  const userUid = review && review.parent && review.parent.uid;

  return (
    <React.Fragment>
      <ReviewHeader
        user={review.parent}
        userName={name}
        userLink={parentPath(userUid)}
        responseTime={review.created_at}
        // @ts-ignore TS(2322): Type 'null' is not assignable to type 'LightActivi... Remove this comment to see the full error message
        activity={null}
      />

      <Box
        sx={{
          paddingBottom: "1em",
        }}
      >
        {review.activity_star_rating && (
          <StarRatings rating={review.activity_star_rating} />
        )}
      </Box>

      <CollapsedText
        allowCollapse={false}
        maxCharacters={maxReviewTextChars}
        showLessLabel={t("Show Less")}
        showMoreLabel={t("Show More")}
      >
        {publicReview}
      </CollapsedText>
    </React.Fragment>
  );
};
